import React, { useRef, useEffect } from "react";
import { useState } from "react";

// Libraries
import { Rect, Transformer, Text, Group } from "react-konva";

const TransformableText = ({
  frameOne,
  selectedFrame,
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  name,
  colour,
  fontFamily,
  fontStyle,
  fontColor,
  alignment,
  fontSize,
  x,
  y,
  color,
  width,
  textTransform,
  height,
}) => {
  const [xaxis, setXaxis] = useState();
  const [yaxis, setYaxis] = useState(250);
  const [xAxisWidth, setXAxisWidth] = useState(200);
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (isSelected && trRef.current && shapeRef.current) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  // useEffect(() => {
  //   if (selectedFrame === frameOne) {
  //     setXaxis(83.7)
  //     setYaxis(95)
  //     setXAxisWidth(200)

  //   } else {
  //     setXaxis(143)
  //     setYaxis(92)
  //     setXAxisWidth(150)
  //   }
  // }, [selectedFrame])

  return (
    <>
      <Group
        // onClick={onSelect}
        id={shapeProps.id}
        // onTap={onSelect}
        ref={shapeRef}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...shapeProps}
        // draggable
        // onDragEnd={(e) => {
        //   console.log(e.target.attrs.y)
        //   onChange({
        //     ...shapeProps,
        //     x: e.target.x(),
        //     y: e.target.y()
        //   });
        // }}
        // onTransformEnd={() => {
        //   console.log(e.target.attrs.y)
        //   if (shapeRef.current) {
        //     const node = shapeRef.current;
        //     onChange({
        //       ...shapeProps,
        //       x: node.x(),
        //       y: node.y(),

        //     });
        //   }
        // }}
      >
        <Rect
          width={xAxisWidth}
          height={9}
          x={x}
          y={yaxis}
          cornerRadius={[7, 7, 7, 7]}
        />
        <Text
          x={x}
          y={y}
          width={width || xAxisWidth}
          height={height || 40}
          align={alignment || "end"}
          verticalAlign="top"
          text={name}
          fill={color}
          lineHeight={1.4}
          fontSize={fontSize}
          fontFamily={fontFamily || "Laila"}
          fontStyle={fontStyle}
          textTransform={textTransform || "none"}
          wrap="word"
        />
      </Group>
      {isSelected && (
        <Transformer
          ref={trRef}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ]}
          boundBoxFunc={(oldBox, newBox) =>
            newBox.width < 5 || newBox.height < 5 ? oldBox : newBox
          }
        />
      )}
    </>
  );
};

export default TransformableText;
